import { render } from "./DeviceProfileTemplateCreate.vue?vue&type=template&id=3a9c524e"
import script from "./DeviceProfileTemplateCreate.vue?vue&type=script&lang=js"
export * from "./DeviceProfileTemplateCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__